import type { AssetSheetCellFormat, AssetSheetCellFormatPatch } from '@atlas/types'

/** `format` with the patch's rules applied key by key: a null removes the rule, a rule left out stays as it was. */
export function applyCellFormatPatch(
	format: AssetSheetCellFormat,
	patch: AssetSheetCellFormatPatch,
): AssetSheetCellFormat {
	const next: Record<string, unknown> = { ...format }
	for (const [rule, value] of Object.entries(patch)) {
		if (value === null) delete next[rule]
		else if (value !== undefined) next[rule] = value
	}
	return next as AssetSheetCellFormat
}
